import React from "react";
import { connect } from "react-redux";
import store from "../Redux/store";

class DarkOverlay extends React.Component {
    constructor() {
        super();
        this.onClose = this.onClose.bind(this);
    }

    onClose(e) {
        if (this.props.closeSelf && e.target.className.indexOf("dark-overlay") >= 0) {
            store.dispatch(this.props.closeSelf({ visible: false }));
        }
    }

    render() {
        var opacity = this.props.opacity ? this.props.opacity : 30;
        var top = this.props.top === 0 ? 0 : 64;

        return <div className={"dark-overlay" + (this.props.visible ? "" : " hidden") + (this.props.className ? " " + this.props.className : "")} style={{
                background: "rgb(0 0 0 / " + opacity + "%)",
                top,
                height: "calc(100% - " + top +"px)",
                zIndex: (this.props.belowNavBar === true) ? 999 : 99999
            }} onClick={this.onClose}>
                {this.props.children}
        </div>
    }
}

export default connect()(DarkOverlay);